import React from 'react';

import styles from './index.module.scss';

function SplitterVertical() {
  return <div className={styles.splitter} />;
}

export default SplitterVertical;
